import React, { Component } from 'react';
import ItemModify from '../Form/ItemModify';
import { inject, observer } from 'mobx-react';
import { timezones } from '../../libs/date';

@inject('dataSourceStore', 'dataOriginStore', 'dataOriginParameterTemplateStore')
@observer
class DataSourceOriginModify extends Component {

  componentWillMount() {
    const { dataOriginParameterTemplateStore } = this.props;
    if (!dataOriginParameterTemplateStore.isLoading && !dataOriginParameterTemplateStore.items.length) dataOriginParameterTemplateStore.fetchItems();
  }

  onSave = () => {
    const { params: { id }, dataSourceStore } = this.props;
    dataSourceStore.fetchItem(id, true);
  }

  render() {
    const { params: { id, dataOriginId }, dataOriginStore, dataSourceStore, dataOriginParameterTemplateStore } = this.props;
    return (
      <ItemModify
        title='Data Origin'
        slug={`/daq/data-source/${id}/data-origin`}
        store={dataOriginStore}
        itemFields={[
          { label: 'Id', key: 'id', editOnly: true, readOnly: true },
          { label: 'Data Source', key: 'data_source_id', type: 'select', options: dataSourceStore.items, fields: { label: 'name', value: 'id' }, defaultValue: +id, readOnly: true },
          { label: 'Code', key: 'code', type: 'text' },
          { label: 'Timezone', key: 'timezone', type: 'select', options: timezones, fields: { label: 'offset', value: 'offset' } },
          { label: 'Parameter Template', key: 'parameterTemplate', type: 'select', options: dataOriginParameterTemplateStore.items, fields: { label: 'name', value: 'id' } },
          { label: 'Block', key: 'block', type: 'checkbox-numeric', defaultValue: 0, editOnly: true },
        ]}
        params={{ id: dataOriginId }}
        onSave={this.onSave}
        isLoading={dataOriginParameterTemplateStore.isLoading}
      />
    );
  }
}

export default DataSourceOriginModify;


// WEBPACK FOOTER //
// ./src/components/DataSource/DataSourceOriginModify.js